var LazyBg = {};

LazyBg.jaLazyBg = false;

LazyBg.verify = function (){
	$('[data-lazy-bg]').each(function(index, el){
		if(el.getBoundingClientRect().top <= (window.innerHeight + 200)){
			var bg = $(this).data('lazy-bg');

			$(el).css('background-image', `url(${bg})`);

			$(el).removeAttr('data-lazy-bg');
		}
	})
}

LazyBg.start = (function(){
	LazyBg.verify();

	$(window).scroll(function(){
		if(LazyBg.jaLazyBg) return;

		setTimeout(function(){
			LazyBg.jaLazyBg = false;
		},100);

		LazyBg.verify();
	});
})();